<template>
  <section class="p-16 mb-6" style="background: #F7F7F7; border-bottom: 2px solid #E0E0E0">
    <div class="mb-16">
      <bl-text-av tag="h2" class="mb-8" variation="body-14">
        {{ aperd.title }}
      </bl-text-av>
      <bl-flex-container-mv align-items="center">
        <bl-flex-item-av v-for="(logo, index) in aperd.logoUrls" :key="index">
          <new-webp-image-container
            :alt="logo.alt"
            :class="{ 'ml-20': index !== 0 }"
            :src="`partner_logos/mobile/${logo.src}`"
            :is-ssr="isSSR"
          />
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>

    <div>
      <bl-flex-container-mv align-items="center">
        <bl-flex-item-av :grow="1" basis="50%">
          <bl-text-av tag="h2" class="mb-8" variation="body-14">
            {{ ojk.title }}
          </bl-text-av>
          <new-webp-image-container
            :alt="ojk.logoUrl.alt"
            :src="`partner_logos/mobile/${ojk.logoUrl.src}`"
            :is-ssr="isSSR"
            styles="width: 64px; height: 24px;"
          />
        </bl-flex-item-av>

        <bl-flex-item-av class="u-txt--center" :grow="1" basis="50%" style="border-left: 1px solid #D6D6D6;">
          <bl-text-av tag="h2" class="mb-8" variation="body-14">
            {{ partner.title }}
          </bl-text-av>
          <new-webp-image-container
            v-for="(logo, index) in partner.logoUrls"
            :key="index"
            :alt="logo.alt"
            :class="{ 'ml-20': index !== 0 }"
            :src="`partner_logos/mobile/${logo.src}`"
            :is-ssr="isSSR"
            styles="width: 64px; height: 24px;"
          />
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { Footer as footer } from 'shared/modules/seo/Homepage';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexItemAv';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';

export default {
  name: 'Footer',

  footer,

  components: {
    BlFlexContainerMv,
    BlFlexItemAv,
    BlTextAv,
    NewWebpImageContainer,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    aperd() {
      return this.$options.footer.aperd;
    },

    ojk() {
      return this.$options.footer.ojk;
    },

    partner() {
      return this.$options.footer.partner;
    },
  },
};
</script>
